var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9375 5.25C0.9375 2.86827 2.86827 0.9375 5.25 0.9375H12.75C15.1317 0.9375 17.0625 2.86827 17.0625 5.25V12.75C17.0625 15.1317 15.1317 17.0625 12.75 17.0625H5.25C2.86827 17.0625 0.9375 15.1317 0.9375 12.75V5.25ZM6.72725 9.02275L8.22725 10.5227C8.44692 10.7424 8.80308 10.7424 9.02275 10.5227L12.0227 7.52275C12.2424 7.30308 12.2424 6.94692 12.0227 6.72725C11.8031 6.50758 11.4469 6.50758 11.2273 6.72725L8.625 9.3295L7.52275 8.22725C7.30308 8.00758 6.94692 8.00758 6.72725 8.22725C6.50758 8.44692 6.50758 8.80308 6.72725 9.02275Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/check-box.23bdd2d1e28c3ccd5b0aaacd7642969b.svg";
export { ForwardRef as ReactComponent };